import {
  TAppContext,
  TAppContextReducerAction,
  TPrivacyCenterContent,
  TUserData,
  TEntity,
  IGetEntityMenuResponse,
} from '../types'

const appContextReducer = (state: TAppContext, action: TAppContextReducerAction): TAppContext => {
  switch (action.type) {
    case 'SET_APP_LOADING':
      return {
        ...state,
        isAppLoading: action.payload,
      }

    case 'SET_APP_ERROR':
      return {
        ...state,
        isAppError: action.payload,
      }

    case 'SET_USER_DATA':
      return {
        ...state,
        ...action.payload,
        userEntities: action.payload.userEntities ? [...action.payload.userEntities] : undefined,
      }

    case 'SET_USER_SELECTED_ENTITY':
      return {
        ...state,
        userSelectedEntity: action.payload,
      }

    case 'SET_ENTITY_MENU_CONTENT':
      return {
        ...state,
        entityMenuContent: {
          isActive: action.payload.isActive,
          content: {
            ...action.payload.content,
            menuSection: [...action.payload.content.menuSection],
          },
        },
      }

    case 'SET_CENTRAL_PRIVACY_CONTENT':
      return {
        ...state,
        privacyCenterContent: action.payload,
        appContextCachedAt: action.payload ? Date.now() : undefined,
      }

    case 'SET_QUICK_LOADING':
      return {
        ...state,
        isQuickLoad: action.payload,
      }

    case 'SET_IS_US_BRANCH':
      return {
        ...state,
        isUSBranch: action.payload,
      }

    default:
      return state
  }
}

const appContextReducerActions = {
  setLoading: (isLoading: boolean): TAppContextReducerAction => ({
    type: 'SET_APP_LOADING',
    payload: isLoading,
  }),

  setError: (isError: boolean): TAppContextReducerAction => ({
    type: 'SET_APP_ERROR',
    payload: isError,
  }),

  setUserData: (userData: TUserData): TAppContextReducerAction => ({
    type: 'SET_USER_DATA',
    payload: userData,
  }),

  setUserSelectedEntity: (userData: TEntity | undefined): TAppContextReducerAction => ({
    type: 'SET_USER_SELECTED_ENTITY',
    payload: userData,
  }),

  setEntityMenuContent: (content: IGetEntityMenuResponse): TAppContextReducerAction => ({
    type: 'SET_ENTITY_MENU_CONTENT',
    payload: content,
  }),

  setPrivacyCenterContent: (
    content: TPrivacyCenterContent | undefined,
  ): TAppContextReducerAction => ({
    type: 'SET_CENTRAL_PRIVACY_CONTENT',
    payload: content,
  }),

  setQuickLoad: (content: boolean): TAppContextReducerAction => ({
    type: 'SET_QUICK_LOADING',
    payload: content,
  }),

  setIsUSBranch: (content: boolean): TAppContextReducerAction => ({
    type: 'SET_IS_US_BRANCH',
    payload: content,
  }),
}

export { appContextReducer, appContextReducerActions }
